import { Component, EventEmitter, Input, OnDestroy, Output, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subject } from 'rxjs';
import { NzModalService } from 'ng-zorro-antd/modal';
import {
  AppointmentProductAddEditComponent
} from '../appointment-product-add-edit/appointment-product-add-edit.component';
import { TranslateService, TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { AppointmentFacade } from '../../appointment-facade.service';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'beautyapp-appointment-products',
    templateUrl: './appointment-products.component.html',
    styleUrls: ['./appointment-products.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        NzDividerModule,
        NzIconModule,
        NzButtonModule,
        NzGridModule,
        NzCardModule,
        NzSpaceModule,
        NzPopconfirmModule,
        TranslateModule,
        TranslatePipe
    ]
})
export class AppointmentProductsComponent implements OnDestroy {
  private modalService = inject(NzModalService);
  translateService = inject(TranslateService);

  @Input() bookingId?: string;
  @Input() bookingStatus: any;
  @Input() serviceId?: string | null = null;
  @Input() serviceProducts: any[] = [];
  @Input() viewOnly = false;

  @Output() serviceProductsUpdate: EventEmitter<any[]> = new EventEmitter<
    any[]
  >();
  sub$: Subject<any> = new Subject<any>();

  addEditProduct(appointmentProduct: any = null) {
    const modal = this.modalService.create({
      nzClosable: false,
      nzMaskClosable: false,
      nzTitle: this.translateService.instant(
        appointmentProduct ? 'calendar.editProduct' : 'calendar.addProduct',
      ),
      nzContent: AppointmentProductAddEditComponent,
      nzWidth: '600px',
      nzData: {
        serviceId: this.serviceId,
        appointmentProduct: appointmentProduct
      }
    });

    modal.afterClose.subscribe((res) => {
      console.log(res);
      if (res && res.product) {
        if (res.action === 'update') {
          const productIndex = this.serviceProducts.findIndex(
            (f: any) => f.productId === res.product.productId
          );
          this.serviceProducts = [
            ...this.serviceProducts.slice(0, productIndex),
            res.product,
            ...this.serviceProducts.slice(productIndex + 1)
          ];
        }

        if (res.action === 'create') {
          res.product.extra = true;
          this.serviceProducts = [...this.serviceProducts, res.product];
        }

        this.serviceProductsUpdate.emit(this.serviceProducts);
      }
    });
  }

  delete(index: number) {
    const serviceProducts = [
      ...this.serviceProducts.slice(0, index),
      ...this.serviceProducts.slice(index + 1)
    ];
    this.serviceProductsUpdate.emit(serviceProducts);
  }

  ngOnDestroy(): void {
    this.sub$.next(null);
    this.sub$.complete();
  }

  warningStyle(item: any): any {
    if (item.product && item.product.quantity <= 0 && item.product.grSum <= 0) {
      return { backgroundColor: '#ffdfdf' };
    }

    if (item.quantitySum && item.product.quantity < item.quantitySum) {
      return { backgroundColor: '#f5ffc1' };
    }
    if (item.grSum && item.product.grSum < item.grSum) {
      return { backgroundColor: '#f5ffc1' };
    }
  }
}
